"use strict";

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// THE PATIENT'S INJURIES, AND THE KIT ON THEM, for the patient picture on the controller
// (data/screens/patientstatus.js).
//
//   - detect(scenario) reads the injuries from the scenario's own words (title, presenting complaint,
//     profile): "stabbed in the left flank", "right wrist is deformed", "complete right below knee
//     amputation", "burns to the chest and arms". Only what the text says is drawn; a side the text
//     does not give is drawn on the right and labelled "side not stated".
//   - forScenario(scenario) is what the picture shows: the facilitator's own list (scenario.injuries,
//     set in the Injuries editor) when there is one, otherwise what detect() found.
//   - Body, InjuryLayer and KitLayer are the picture's layers, drawn from the artwork in
//     images/patient/ (data/screens/bodyart.js). The kit (collar, pelvic binder, traction splint,
//     splint, backslab, tourniquet, chest seal, dressing, cling film) appears when its intervention
//     is ticked, on the injured limb where there is one.
//   - InjuryEditor lets the facilitator add or remove injuries during the run.
//
// Nothing here is synced or stored except scenario.injuries, which rides in the scenario like the
// investigation result choices do.
(function () {
  var _React = React,
    useState = _React.useState;

  // ---- the words ---------------------------------------------------------------------------
  var PART = {
    head: 'head',
    scalp: 'head',
    skull: 'head',
    forehead: 'head',
    ear: 'head',
    ears: 'head',
    face: 'face',
    facial: 'face',
    midface: 'face',
    maxillofacial: 'face',
    jaw: 'face',
    chin: 'face',
    nose: 'face',
    cheek: 'face',
    eye: 'eye',
    eyes: 'eye',
    globe: 'eye',
    orbit: 'eye',
    orbital: 'eye',
    retrobulbar: 'eye',
    periorbital: 'eye',
    neck: 'neck',
    sternum: 'sternum',
    sternal: 'sternum',
    chest: 'chest',
    thorax: 'chest',
    rib: 'chest',
    ribs: 'chest',
    hemithorax: 'chest',
    abdomen: 'abdomen',
    abdominal: 'abdomen',
    epigastrium: 'abdomen',
    epigastric: 'abdomen',
    umbilicus: 'abdomen',
    handlebar: 'abdomen',
    handlebars: 'abdomen',
    belly: 'abdomen',
    stomach: 'abdomen',
    flank: 'flank',
    loin: 'flank',
    pelvis: 'pelvis',
    pelvic: 'pelvis',
    perineum: 'pelvis',
    perineal: 'pelvis',
    straddle: 'pelvis',
    groin: 'groin',
    hip: 'hip',
    hips: 'hip',
    nof: 'hip',
    thigh: 'thigh',
    thighs: 'thigh',
    femur: 'thigh',
    femoral: 'thigh',
    femurs: 'thigh',
    aboveknee: 'thigh',
    knee: 'knee',
    knees: 'knee',
    tibia: 'shin',
    tibial: 'shin',
    fibula: 'shin',
    tibfib: 'shin',
    shin: 'shin',
    shins: 'shin',
    calf: 'shin',
    calves: 'shin',
    belowknee: 'shin',
    ankle: 'ankle',
    ankles: 'ankle',
    foot: 'foot',
    feet: 'foot',
    toe: 'foot',
    toes: 'foot',
    heel: 'foot',
    leg: 'leg',
    legs: 'leg',
    humerus: 'upperArm',
    humeral: 'upperArm',
    upperarm: 'upperArm',
    shoulder: 'upperArm',
    elbow: 'upperArm',
    supracondylar: 'upperArm',
    forearm: 'forearm',
    wrist: 'forearm',
    wrists: 'forearm',
    radius: 'forearm',
    ulna: 'forearm',
    colles: 'forearm',
    hand: 'hand',
    hands: 'hand',
    finger: 'hand',
    fingers: 'hand',
    thumb: 'hand',
    palm: 'hand',
    arm: 'arm',
    arms: 'arm'
  };
  // Plural words mean both sides when no side is given ("legs trapped", "arms").
  var PLURAL = new Set(['eyes', 'hips', 'thighs', 'femurs', 'knees', 'shins', 'calves', 'ankles', 'feet', 'legs', 'wrists', 'hands', 'arms']);
  var KIND_RULES = [[/^(fractur|broken|deform|dislocat|flail|angulat|tenting|shortened|rotated)/, 'fracture'], [/^(kendrick|traction)$/, 'traction'], [/^(amputat|severed)/, 'amputation'], [/^evisc/, 'evisceration'], [/^impal/, 'impaled'], [/^(stab|wound|lacerat|gunshot|gsw|bleed|haemorrhag|bubbling|penetrat|slash)/, 'wound'], [/^ruptur/, 'rupture'], [/^(cut|shot)$/, 'wound'], [/^(burn|scald|singed|flame)/, 'burn'], [/^(bruis|abrasion|haematoma|graze|contusion|punch|kick)/, 'bruise'], [/^(bump|struck|seatbelt)$/, 'bruise'], [/^(crush|crushed)$/, 'crush'], [/^injur/, 'injury'], [/^trauma$/, 'injury']];
  var kindOf = function kindOf(w) {
    for (var _i = 0, _KIND_RULES = KIND_RULES; _i < _KIND_RULES.length; _i++) {
      var _KIND_RULES$_i = _slicedToArray(_KIND_RULES[_i], 2),
        re = _KIND_RULES$_i[0],
        k = _KIND_RULES$_i[1];
      if (re.test(w)) return k;
    }
    return null;
  };
  var SIDE = {
    left: 'L',
    right: 'R',
    both: 'both',
    bilateral: 'both'
  };
  var PREP = new Set(['to', 'of', 'in', 'on', 'over', 'at', 'through', 'into', 'onto', 'across', 'around']);
  var CONNECT = new Set([',', 'and', '&', 'or']);
  var FILLER = new Set(['the', 'his', 'her', 'their', 'a', 'an', 'left', 'right', 'both', 'bilateral', 'medial', 'lateral', 'upper', 'lower', 'distal', 'proximal', 'anterior', 'posterior', 'open', 'compound']);
  var NEGATE = new Set(['no', 'not', 'without', 'denies', 'nil']);
  var SIDED = new Set(['eye', 'chest', 'flank', 'groin', 'hip', 'thigh', 'knee', 'shin', 'ankle', 'foot', 'leg', 'upperArm', 'forearm', 'hand', 'arm']);
  var LEG_REGIONS = new Set(['hip', 'thigh', 'knee', 'shin', 'ankle', 'foot']);
  var ARM_REGIONS = new Set(['upperArm', 'forearm', 'hand']);
  var normalise = function normalise(text) {
    return String(text || '').toLowerCase().replace(/[()]/g, ' to ').replace(/neck of (the )?femur|#\s*nof/g, 'nof').replace(/leg through the thigh/g, 'thigh').replace(/below[- ](the[- ])?knee|\bbka\b/g, 'belowknee').replace(/above[- ](the[- ])?knee|\baka\b/g, 'aboveknee').replace(/tib(ia)?\s*\/\s*fib(ula)?/g, 'tibfib').replace(/lower limbs/g, 'legs').replace(/lower limb/g, 'leg').replace(/upper limbs/g, 'arms').replace(/upper limb/g, 'arm').replace(/upper arm/g, 'upperarm').replace(/lower legs?/g, 'shin').replace(/chest wall/g, 'chest').replace(/mid-face/g, 'midface').replace(/seat ?belt (sign|bruis\w*|mark\w*)/g, 'seatbelt').replace(/fracture-dislocation/g, 'fracture dislocation').replace(/trapped under/g, 'crushed under').replace(/traumatic/g, ' ');
  };

  // One clause's injuries: each body part gets the kinds that bind to it.
  function clauseInjuries(clause, out) {
    var toks = clause.match(/[a-z0-9]+|,|&/g) || [];
    var part = toks.map(function (t) {
      return PART[t] || null;
    });
    var kind = toks.map(function (t) {
      return kindOf(t);
    });
    // A kind just after "no" / "not" ("no obvious injuries") says nothing.
    toks.forEach(function (t, i) {
      if (NEGATE.has(t)) for (var j = i + 1; j <= i + 3 && j < toks.length; j++) kind[j] = null;
    });
    // "open" belongs to the fracture word just after it (or the part it comes before), not to
    // the whole clause: "closed fracture of the left femur, open fracture of the right forearm".
    var openTok = function openTok(i) {
      return [toks[i - 1], toks[i - 2]].some(function (t) {
        return t === 'open' || t === 'compound';
      });
    };
    var partOpen = toks.map(function (t, i) {
      return part[i] !== null && openTok(i);
    });
    var kinds = toks.map(function () {
      return [];
    });
    var bindForward = function bindForward(k, from) {
      // "wound to the left ankle", "stabbed twice in the abdomen and groin", "flail chest"
      var j = from + 1,
        prep = false,
        gap = 0;
      while (j < toks.length && part[j] === null && kind[j] === null && gap <= 4) {
        if (CONNECT.has(toks[j])) {
          // "burns and abdominal injury": the burns are not the abdomen's
          var q = j + 1;
          while (q < toks.length && FILLER.has(toks[q])) q++;
          if (q < toks.length && part[q] !== null) return false;
        }
        if (PREP.has(toks[j])) prep = true;else if (!FILLER.has(toks[j])) gap++;
        j++;
      }
      if (j >= toks.length || part[j] === null) return false;
      if (!prep && j - from - 1 > 0 && toks.slice(from + 1, j).some(function (t) {
        return !FILLER.has(t);
      })) return false;
      kinds[j].push(k);
      if (openTok(from)) partOpen[j] = true;
      // chain: "to the chest and arms", "head, chest, arm and leg"
      var p = j;
      for (;;) {
        var _q = p + 1,
          sawConnect = false;
        while (_q < toks.length && (CONNECT.has(toks[_q]) || FILLER.has(toks[_q]))) {
          if (CONNECT.has(toks[_q])) sawConnect = true;
          _q++;
        }
        if (!sawConnect || _q >= toks.length || part[_q] === null) break;
        kinds[_q].push(k);
        if (openTok(from)) partOpen[_q] = true;
        p = _q;
      }
      return true;
    };
    var boundForward = toks.map(function (t, i) {
      return kind[i] ? bindForward(kind[i], i) : false;
    });
    // "right wrist is deformed", "left knee injury with deformity", "tibia injury"
    for (var i = 0; i < toks.length; i++) {
      if (part[i] === null) continue;
      var j = i + 1,
        gap = 0;
      while (j < toks.length && part[j] === null && gap <= 3) {
        if (kind[j] && !boundForward[j]) {
          kinds[i].push(kind[j]);
          if (openTok(j)) partOpen[i] = true;
        } else if (!kind[j] && !CONNECT.has(toks[j]) && !FILLER.has(toks[j])) gap++;
        j++;
      }
    }
    // "head, chest, arm and leg injuries", "abdominal and leg injuries": a part followed only by a
    // connector takes the kinds of the part after it.
    for (var _i2 = toks.length - 1; _i2 >= 0; _i2--) {
      if (part[_i2] === null || kinds[_i2].length) continue;
      var _j = _i2 + 1,
        sawConnect = false;
      while (_j < toks.length && (CONNECT.has(toks[_j]) || FILLER.has(toks[_j]))) {
        if (CONNECT.has(toks[_j])) sawConnect = true;
        _j++;
      }
      if (sawConnect && _j < toks.length && part[_j] !== null) {
        kinds[_i2] = kinds[_j].slice();
        partOpen[_i2] = partOpen[_j];
      }
    }
    for (var _i3 = 0; _i3 < toks.length; _i3++) {
      if (part[_i3] === null || !kinds[_i3].length) continue;
      var side = null;
      for (var _j2 = _i3 - 1; _j2 >= 0; _j2--) if (SIDE[toks[_j2]]) {
        side = SIDE[toks[_j2]];
        break;
      }
      if (!side && PLURAL.has(toks[_i3])) side = 'both';
      var region = part[_i3];
      var ks = new Set(kinds[_i3]);
      if (region === 'sternum') {
        region = 'chest';
        side = 'C';
      }
      if (ks.has('traction') && (region === 'leg' || region === 'thigh')) {
        region = 'thigh';
        ks.add('fracture');
      }
      ks["delete"]('traction');
      // A ruptured globe is an open eye injury; a ruptured spleen or aorta shows nothing outside.
      if (ks.has('rupture') && region === 'eye') ks.add('wound');
      ks["delete"]('rupture');
      if (!ks.size) continue;
      // An amputation "at the wrist" takes the hand.
      if (ks.has('amputation') && /^wrists?$/.test(toks[_i3])) region = 'hand';
      out.push({
        region: region,
        kinds: ks,
        side: side,
        open: partOpen[_i3],
        word: toks[_i3]
      });
    }
  }
  var SEVERITY = ['amputation', 'evisceration', 'impaled', 'fracture', 'wound', 'burn', 'crush', 'bruise', 'injury'];
  function detect(scenario) {
    var s = scenario || {};
    var profile = s.profile || (window.formatProfileTemplate ? window.formatProfileTemplate(s.patientProfileTemplate || '', s.patientAge, s.sex) : s.patientProfileTemplate || '');
    var text = normalise([s.title, s.presentingComplaint, profile].filter(Boolean).join('. '));
    var raw = [];
    text.split(/[.;!?:\n]+/).forEach(function (c) {
      return clauseInjuries(c, raw);
    });
    // Sides the text gives for a region anywhere ("discharged into the left index finger").
    var statedSide = {};
    text.split(/[.;!?:\n]+/).forEach(function (c) {
      var toks = c.match(/[a-z0-9]+/g) || [];
      toks.forEach(function (t, i) {
        if (!PART[t]) return;
        for (var j = i - 1; j >= Math.max(0, i - 4); j--) if (SIDE[toks[j]] && SIDE[toks[j]] !== 'both') {
          statedSide[PART[t]] = statedSide[PART[t]] || SIDE[toks[j]];
          break;
        }
      });
    });
    var list = [];
    raw.forEach(function (r) {
      var kind = SEVERITY.find(function (k) {
        return r.kinds.has(k);
      });
      var open = kind === 'fracture' && (r.open || r.kinds.has('wound'));
      if (r.region === 'abdomen' && r.kinds.has('evisceration')) kind = 'evisceration';
      var sides = [r.side];
      var guessed = false;
      if (SIDED.has(r.region)) {
        if (r.side === 'both') sides = ['R', 'L'];else if (!r.side || r.side === 'C') {
          // The front of the chest: the sternum, or burns or bruising given no side.
          if (r.region === 'chest' && (r.side === 'C' || !r.side && ['burn', 'bruise', 'injury'].indexOf(kind) !== -1)) sides = ['C'];else if (statedSide[r.region]) sides = [statedSide[r.region]];else {
            sides = ['R'];
            guessed = true;
          }
        }
      } else sides = [null];
      sides.forEach(function (side) {
        return list.push({
          region: r.region,
          kind: kind,
          side: side,
          open: !!open,
          guessed: guessed
        });
      });
    });
    // A visible bump from 20 weeks: "32 weeks pregnant", "at 34 weeks", "term pregnancy", or pregnant
    // with no gestation given (but not an early pregnancy: ectopic, miscarriage, a positive test).
    var gm = text.match(/\b(?:at|pregnant,?\s*(?:to\s*)?)\s*(\d{1,2})\s*weeks\b|\b(\d{1,2})\s*weeks'?\s*(?:pregnant|gestation)/);
    var weeks = gm ? Number(gm[1] || gm[2]) : null;
    var pregnant = /\bpregnan/.test(text) && !/\bnot pregnan/.test(text);
    if (weeks !== null && weeks >= 20 || /\bterm pregnancy\b/.test(text) || pregnant && weeks === null && !/positive pregnancy test|ectopic|early pregnancy|miscarri/.test(text)) {
      list.push({
        region: 'abdomen',
        kind: 'pregnant',
        side: null,
        open: false,
        guessed: false
      });
    }
    // Burns the text gives no place for ("40% TBSA burns"): the chest and both arms, labelled so.
    if (/\b(burn|burns|burnt|scald|scalds|scalded)\b/.test(text) && !list.some(function (i) {
      return i.kind === 'burn';
    })) {
      list.push({
        region: 'chest',
        kind: 'burn',
        side: 'C',
        open: false,
        guessed: true,
        areaGuessed: true
      });
      list.push({
        region: 'arm',
        kind: 'burn',
        side: 'R',
        open: false,
        guessed: false,
        areaGuessed: true
      });
      list.push({
        region: 'arm',
        kind: 'burn',
        side: 'L',
        open: false,
        guessed: false,
        areaGuessed: true
      });
    }
    return tidy(list);
  }

  // One entry per place and kind; an open fracture absorbs the wound at the same place; a stated
  // side beats a guessed one; a vague "leg injury" gives way to a named part of that leg.
  function tidy(list) {
    var key = function key(i) {
      return "".concat(i.region, "|").concat(i.side || '', "|").concat(i.kind);
    };
    var seen = new Map();
    list.forEach(function (i) {
      if (!seen.has(key(i)) || seen.get(key(i)).guessed && !i.guessed) seen.set(key(i), i);
    });
    var out = Array.from(seen.values());
    out.forEach(function (f) {
      if (f.kind === 'fracture' && out.some(function (w) {
        return w.kind === 'wound' && w.region === f.region && w.side === f.side;
      })) f.open = true;
    });
    out = out.filter(function (i) {
      return !(i.kind === 'wound' && out.some(function (f) {
        return f.kind === 'fracture' && f.region === i.region && f.side === i.side;
      }));
    });
    out = out.filter(function (i) {
      return !(i.guessed && out.some(function (o) {
        return o !== i && o.region === i.region && o.kind === i.kind && !o.guessed;
      }));
    });
    out = out.filter(function (i) {
      return !(i.kind !== 'amputation' && out.some(function (o) {
        return o.kind === 'amputation' && o.region === i.region && o.side === i.side;
      }));
    });
    // A plain "injury" (or a wound beside an evisceration) adds nothing to a named injury at the same place.
    var samePlace = function samePlace(a, b) {
      return a !== b && a.region === b.region && a.side === b.side;
    };
    out = out.filter(function (i) {
      return !(i.kind === 'injury' && out.some(function (o) {
        return o !== i && o.region === i.region && o.kind !== 'injury' && o.kind !== 'pregnant';
      }));
    });
    out = out.filter(function (i) {
      return !(i.kind === 'wound' && out.some(function (o) {
        return samePlace(o, i) && o.kind === 'evisceration';
      }));
    });
    out = out.filter(function (i) {
      return !(i.kind === 'bruise' && out.some(function (o) {
        return samePlace(o, i) && (o.kind === 'wound' || o.kind === 'fracture');
      }));
    });
    var specific = function specific(generic, set) {
      return out.some(function (o) {
        return set.has(o.region) && (o.side === generic.side || generic.guessed);
      });
    };
    var vague = function vague(i) {
      return i.guessed || i.kind === 'injury' || i.kind === 'bruise';
    };
    out = out.filter(function (i) {
      return !(i.region === 'leg' && vague(i) && specific(i, LEG_REGIONS));
    });
    out = out.filter(function (i) {
      return !(i.region === 'arm' && vague(i) && specific(i, ARM_REGIONS));
    });
    // A hip fracture and a vague fracture of the same leg are the same injury.
    return out;
  }
  var cache = new Map();
  function forScenario(scenario) {
    if (!scenario) return [];
    if (Array.isArray(scenario.injuries)) return scenario.injuries.filter(function (i) {
      return i && REGION_NAME[i.region] && KIND_NAME[i.kind];
    });
    var k = [scenario.id, scenario.title, scenario.presentingComplaint, scenario.profile, scenario.patientProfileTemplate].join('|');
    if (!cache.has(k)) {
      if (cache.size > 50) cache.clear();
      cache.set(k, detect(scenario));
    }
    return cache.get(k);
  }

  // ---- the words for people ----------------------------------------------------------------
  var REGION_NAME = {
    head: 'head',
    face: 'face',
    eye: 'eye',
    neck: 'neck',
    chest: 'chest',
    abdomen: 'abdomen',
    flank: 'flank',
    pelvis: 'pelvis',
    groin: 'groin',
    hip: 'hip',
    thigh: 'thigh',
    knee: 'knee',
    shin: 'lower leg',
    ankle: 'ankle',
    foot: 'foot',
    leg: 'leg',
    upperArm: 'upper arm / elbow',
    forearm: 'forearm / wrist',
    hand: 'hand',
    arm: 'arm'
  };
  var KIND_NAME = {
    fracture: 'fracture',
    amputation: 'amputation',
    wound: 'wound',
    evisceration: 'evisceration',
    impaled: 'impaled object',
    burn: 'burns',
    bruise: 'bruising',
    crush: 'crush injury',
    injury: 'injury',
    pregnant: 'pregnant'
  };
  var SPECIAL = {
    'thigh|fracture': 'femur fracture',
    'shin|fracture': 'tibia / fibula fracture',
    'leg|fracture': 'leg fracture',
    'hip|fracture': 'hip fracture (leg shortened and rotated)',
    'chest|fracture': 'rib fractures',
    'knee|fracture': 'knee dislocation / deformity',
    'ankle|fracture': 'ankle fracture-dislocation',
    'pelvis|fracture': 'pelvic fracture',
    'head|fracture': 'skull fracture',
    'face|fracture': 'facial fractures',
    'upperArm|fracture': 'upper arm / elbow fracture',
    'forearm|fracture': 'forearm / wrist fracture',
    'thigh|amputation': 'amputation through the thigh',
    'shin|amputation': 'below-knee amputation',
    'leg|amputation': 'below-knee amputation',
    'hand|amputation': 'hand amputated at the wrist',
    'forearm|amputation': 'forearm amputation',
    'arm|amputation': 'forearm amputation',
    'abdomen|evisceration': 'abdominal wound with evisceration',
    'abdomen|impaled': 'impaled object in the abdomen',
    'abdomen|pregnant': 'pregnant',
    'head|injury': 'head injury',
    'head|bruise': 'scalp bruising / haematoma',
    'abdomen|injury': 'abdominal injury',
    'abdomen|bruise': 'abdominal bruising',
    'abdomen|wound': 'abdominal wound',
    'abdomen|burn': 'abdominal burns',
    'pelvis|injury': 'pelvic injury',
    'pelvis|bruise': 'pelvic bruising',
    'face|injury': 'facial injuries',
    'face|bruise': 'facial bruising',
    'face|wound': 'facial wound',
    'face|burn': 'facial burns'
  };
  function label(i) {
    var base = SPECIAL["".concat(i.region, "|").concat(i.kind)] || "".concat(REGION_NAME[i.region], " ").concat(KIND_NAME[i.kind]);
    var side = i.side === 'R' ? 'Right ' : i.side === 'L' ? 'Left ' : '';
    var s = side ? side + base : base.charAt(0).toUpperCase() + base.slice(1);
    if (i.open && i.kind === 'fracture') s += ' (open)';
    if (i.areaGuessed) s += ' (areas not stated)';else if (i.guessed && side) s += ' (side not stated)';
    return s;
  }

  // What the facilitator can add.
  var PRESETS = [['head', 'injury'], ['face', 'injury'], ['eye', 'bruise'], ['neck', 'wound'], ['chest', 'wound'], ['chest', 'fracture'], ['abdomen', 'wound'], ['abdomen', 'bruise'], ['abdomen', 'evisceration'], ['abdomen', 'impaled'], ['flank', 'wound'], ['pelvis', 'fracture'], ['groin', 'wound'], ['hip', 'fracture'], ['thigh', 'fracture'], ['thigh', 'wound'], ['knee', 'fracture'], ['shin', 'fracture'], ['ankle', 'fracture'], ['leg', 'crush'], ['thigh', 'amputation'], ['shin', 'amputation'], ['upperArm', 'fracture'], ['forearm', 'fracture'], ['hand', 'wound'], ['hand', 'amputation'], ['face', 'burn'], ['chest', 'burn'], ['abdomen', 'burn'], ['arm', 'burn'], ['leg', 'burn'], ['abdomen', 'pregnant']].map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      region = _ref2[0],
      kind = _ref2[1];
    return {
      region: region,
      kind: kind,
      sided: SIDED.has(region) && !(region === 'chest' && kind === 'burn'),
      name: label({
        region: region,
        kind: kind,
        side: null
      }).replace(/ \(.*\)$/, '')
    };
  });

  // ---- where things are on the picture ------------------------------------------------------
  // The picture is 220 x 250, the patient seen from above with the head at the top, so the
  // patient's RIGHT is on the LEFT of the picture. The body is the generated artwork in
  // images/patient/ (data/screens/bodyart.js), cut into a torso and four pieces per limb. Each
  // limb is a chain of six points from the art: the root (shoulder or hip), mid-bone, the elbow
  // or knee, mid-bone, the wrist or ankle, and the end of the hand or the toes. Pieces 1 to 4
  // start at points 1 to 4: a fracture turns the pieces below it about a point, and an
  // amputation leaves them off.
  var mx = function mx(side, x) {
    return side === 'L' ? 190 - x : x;
  };
  var injAt = function injAt(list, side, regions, kinds) {
    return list.find(function (i) {
      return i.side === side && regions.indexOf(i.region) !== -1 && (!kinds || kinds.indexOf(i.kind) !== -1);
    });
  };
  var lerp = function lerp(a, b, t) {
    return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t];
  };
  // As SVG's rotate(deg cx cy): positive turns clockwise on the screen
  var rotAbout = function rotAbout(p, c, deg) {
    var r = deg * Math.PI / 180,
      s = Math.sin(r),
      k = Math.cos(r),
      dx = p[0] - c[0],
      dy = p[1] - c[1];
    return [c[0] + dx * k - dy * s, c[1] + dx * s + dy * k];
  };
  var angle = function angle(a, b) {
    return Math.atan2(b[1] - a[1], b[0] - a[0]) * 180 / Math.PI;
  };

  // Where each point of a chain ends up: turned by every bend at or above its piece, the lowest
  // bend first (the nesting of the SVG groups in LimbArt), and moved up by `dy` (a hip fracture's
  // shortening) unless it is the root.
  function pose(rest, rot, dy) {
    return rest.map(function (q, i) {
      if (i === 0) return q;
      var p = q;
      for (var j = Math.min(i, 4); j >= 1; j--) if (rot[j]) p = rotAbout(p, rest[j], rot[j]);
      return [p[0], p[1] + (dy || 0)];
    });
  }

  // The limbs' joints, bent where a fracture deforms them, short where an amputation took them.
  // `F` is the body's frame from BodyArt.frame() (the man when it is not given).
  function geometry(list, F) {
    var BA = window.BodyArt;
    F = F || BA.frame();
    var z = F.S / BA.BASE;
    var g = {
      F: F,
      T: F.T,
      z: z
    };
    ['R', 'L'].forEach(function (side) {
      var out = side === 'L' ? -1 : 1; // the rotation that swings the lower part outward
      var has = function has(regions, kinds) {
        return !!injAt(list, side, regions, kinds);
      };
      var J = F.art.joints[side];
      var restA = J.arm.map(F.at),
        restL = J.leg.map(F.at);
      var ar = [0, 0, 0, 0, 0],
        lr = [0, 0, 0, 0, 0];
      if (has(['upperArm'], ['fracture'])) ar[1] = 18 * out;
      if (has(['forearm', 'arm'], ['fracture'])) ar[3] = 18 * out;
      if (has(['thigh'], ['fracture'])) lr[1] = 14 * out;
      if (has(['knee'], ['fracture'])) lr[2] = 12 * out;
      if (has(['shin', 'leg'], ['fracture'])) lr[3] = 14 * out;
      var hipFx = has(['hip'], ['fracture']);
      if (has(['ankle'], ['fracture'])) lr[4] += 30 * out;
      if (hipFx) lr[4] += 45 * out; // shortened and externally rotated
      var dy = hipFx ? -5 * z : 0;
      var aCut = has(['forearm', 'arm'], ['amputation']) ? 3 : has(['hand'], ['amputation']) ? 4 : 5;
      var lCut = has(['thigh'], ['amputation']) ? 1 : has(['shin', 'leg'], ['amputation']) ? 3 : 5;
      var A = pose(restA, ar, 0),
        L = pose(restL, lr, dy);
      var arm = {
        rest: restA,
        rot: ar,
        cut: aCut,
        dy: 0,
        pts: A,
        segs: [{
          pts: [A[0], A[2]]
        }, {
          pts: [A[2], A[Math.min(aCut, 4)]]
        }],
        hand: aCut === 5 ? lerp(A[4], A[5], 0.45) : null,
        stump: aCut < 5 ? A[aCut] : null,
        mid: {
          upperArm: A[1],
          forearm: A[3],
          hand: lerp(A[4], A[5], 0.45)
        }
      };
      var legSegs = [{
        pts: [L[0], lCut === 1 ? L[1] : L[2]]
      }];
      if (lCut >= 3) legSegs.push({
        pts: [L[2], L[Math.min(lCut, 4)]]
      });
      var leg = {
        rest: restL,
        rot: lr,
        cut: lCut,
        dy: dy,
        pts: L,
        segs: legSegs,
        foot: lCut === 5 ? lerp(L[4], L[5], 0.5) : null,
        ankle: lCut === 5 ? L[4] : null,
        stump: lCut < 5 ? L[lCut] : null,
        mid: {
          hip: lerp(L[0], [95, L[0][1]], 0.25),
          thigh: L[1],
          knee: L[2],
          shin: L[3],
          ankle: L[4],
          foot: lerp(L[4], L[5], 0.5),
          leg: L[3]
        }
      };
      g[side] = {
        arm: arm,
        leg: leg
      };
    });
    return g;
  }

  // Places on the trunk and head, for the adult man; g.T moves them onto the body shown.
  var POINT = {
    head: function head() {
      return [95, 15];
    },
    face: function face() {
      return [95, 36];
    },
    neck: function neck() {
      return [95, 51];
    },
    abdomen: function abdomen() {
      return [95, 108];
    },
    pelvis: function pelvis() {
      return [95, 130];
    },
    eye: function eye(s) {
      return [mx(s, 89), 28];
    },
    chest: function chest(s) {
      return s === 'C' ? [95, 76] : [mx(s, 82), 80];
    },
    flank: function flank(s) {
      return [mx(s, 74), 110];
    },
    groin: function groin(s) {
      return [mx(s, 87), 141];
    }
  };
  function pointFor(i, g) {
    if (POINT[i.region]) return g.T(POINT[i.region](i.side || 'R'));
    var side = i.side === 'L' ? 'L' : 'R';
    var G = g[side];
    if (ARM_REGIONS.has(i.region) || i.region === 'arm') return G.arm.mid[i.region === 'arm' ? 'forearm' : i.region];
    return G.leg.mid[i.region] || G.leg.mid.shin;
  }

  // ---- the layers ---------------------------------------------------------------------------
  // A kit or injury picture, centred on `c`, `w` wide (and `h` high, or its own shape), turned by `rot`.
  var Sprite = function Sprite(_ref3) {
    var name = _ref3.name,
      c = _ref3.c,
      w = _ref3.w,
      h = _ref3.h,
      rot = _ref3.rot,
      opacity = _ref3.opacity,
      flip = _ref3.flip;
    var H = h || window.BodyArt.kitH(name, w);
    var t = [rot ? "rotate(".concat(rot, " ").concat(c[0], " ").concat(c[1], ")") : '', flip ? "translate(".concat(2 * c[0], " 0) scale(-1 1)") : ''].join(' ').trim();
    return /*#__PURE__*/React.createElement("image", {
      href: window.BodyArt.kitSrc(name),
      x: c[0] - w / 2,
      y: c[1] - H / 2,
      width: w,
      height: H,
      preserveAspectRatio: "none",
      transform: t || undefined,
      opacity: opacity
    });
  };

  // One limb: its pieces nested so each bend carries everything below it.
  var LimbArt = function LimbArt(_ref4) {
    var F = _ref4.F,
      side = _ref4.side,
      limb = _ref4.limb,
      L = _ref4.L;
    var BA = window.BodyArt;
    var inner = null;
    for (var k = Math.min(L.cut - 1, 4); k >= 1; k--) {
      var box = BA.place(F, F.art.pieces["".concat(side).concat(limb).concat(k)]);
      inner = /*#__PURE__*/React.createElement("g", {
        transform: L.rot[k] ? "rotate(".concat(L.rot[k], " ").concat(L.rest[k][0], " ").concat(L.rest[k][1], ")") : undefined
      }, /*#__PURE__*/React.createElement("image", _extends({
        href: BA.src(F, "".concat(side).concat(limb).concat(k))
      }, box, {
        preserveAspectRatio: "none"
      })), inner);
    }
    return /*#__PURE__*/React.createElement("g", {
      transform: L.dy ? "translate(0 ".concat(L.dy, ")") : undefined
    }, inner);
  };

  // The patient: the torso (head, trunk, shorts and the tops of the limbs), the chest rising and
  // falling with each breath, the eyes closed when they are, then the legs and the arms.
  // `tint` is the id of an SVG filter (cyanosed, or in arrest).
  var Body = function Body(_ref5) {
    var g = _ref5.g,
      eyesClosed = _ref5.eyesClosed,
      breathe = _ref5.breathe,
      breathDur = _ref5.breathDur,
      tint = _ref5.tint;
    var BA = window.BodyArt,
      F = g.F;
    var torso = BA.place(F, F.art.pieces.torso),
      chest = BA.place(F, F.art.pieces.chest),
      eyes = BA.place(F, F.art.pieces.eyesClosed);
    var c = F.at(F.art.chest);
    return /*#__PURE__*/React.createElement("g", {
      "data-part": "body",
      filter: tint ? "url(#".concat(tint, ")") : undefined
    }, /*#__PURE__*/React.createElement("image", _extends({
      href: BA.src(F, 'torso')
    }, torso, {
      preserveAspectRatio: "none"
    })), /*#__PURE__*/React.createElement("g", {
      transform: "translate(".concat(c[0], " ").concat(c[1], ")")
    }, /*#__PURE__*/React.createElement("g", null, breathe && /*#__PURE__*/React.createElement("animateTransform", {
      attributeName: "transform",
      type: "scale",
      values: "1 1;1.035 1.02;1 1",
      dur: breathDur,
      repeatCount: "indefinite"
    }), /*#__PURE__*/React.createElement("image", {
      href: BA.src(F, 'chest'),
      x: chest.x - c[0],
      y: chest.y - c[1],
      width: chest.width,
      height: chest.height,
      preserveAspectRatio: "none"
    }))), eyesClosed && /*#__PURE__*/React.createElement("image", _extends({
      "data-part": "eyes-closed",
      href: BA.src(F, 'eyesClosed')
    }, eyes, {
      preserveAspectRatio: "none"
    })), /*#__PURE__*/React.createElement("g", {
      "data-part": "limbs"
    }, ['R', 'L'].map(function (side) {
      return /*#__PURE__*/React.createElement(LimbArt, {
        key: 'l' + side,
        F: F,
        side: side,
        limb: "leg",
        L: g[side].leg
      });
    }), ['R', 'L'].map(function (side) {
      return /*#__PURE__*/React.createElement(LimbArt, {
        key: 'a' + side,
        F: F,
        side: side,
        limb: "arm",
        L: g[side].arm
      });
    })));
  };
  var BURN_SHAPE = {
    chest: function chest(s) {
      return s === 'C' || !s ? {
        c: [95, 82],
        rx: 22,
        ry: 17
      } : {
        c: [mx(s, 84), 82],
        rx: 11,
        ry: 15
      };
    },
    abdomen: function abdomen() {
      return {
        c: [95, 108],
        rx: 18,
        ry: 11
      };
    },
    face: function face() {
      return {
        c: [95, 32],
        rx: 12,
        ry: 13
      };
    },
    eye: function eye(s) {
      return {
        c: [mx(s, 89), 28],
        rx: 4,
        ry: 3.5
      };
    },
    neck: function neck() {
      return {
        c: [95, 51],
        rx: 7,
        ry: 6
      };
    },
    head: function head() {
      return {
        c: [95, 20],
        rx: 13,
        ry: 9
      };
    }
  };
  function burnShape(i, g) {
    if (BURN_SHAPE[i.region]) {
      var b = BURN_SHAPE[i.region](i.side);
      return {
        c: g.T(b.c),
        rx: b.rx * g.F.kx,
        ry: b.ry * g.F.ky,
        rot: 0
      };
    }
    var side = i.side === 'L' ? 'L' : 'R';
    var G = g[side],
      z = g.z;
    // along the limb: from one point of its chain to another
    var along = function along(P, a, b, w) {
      return {
        c: lerp(P[a], P[b], 0.5),
        rx: w * z,
        ry: Math.hypot(P[b][0] - P[a][0], P[b][1] - P[a][1]) / 2 + 2 * z,
        rot: angle(P[a], P[b]) - 90
      };
    };
    var A = G.arm.pts,
      L = G.leg.pts;
    if (i.region === 'arm') return along(A, 0, Math.min(G.arm.cut, 4), 6);
    if (i.region === 'upperArm') return along(A, 0, 2, 6);
    if (i.region === 'forearm') return along(A, 2, Math.min(G.arm.cut, 4), 5.5);
    if (i.region === 'hand') return {
      c: G.arm.mid.hand,
      rx: 5 * z,
      ry: 7 * z,
      rot: 0
    };
    if (i.region === 'leg') return along(L, 0, Math.min(G.leg.cut, 4), 8.5);
    if (i.region === 'thigh' || i.region === 'hip') return along(L, 0, Math.min(G.leg.cut, 2), 8);
    if (i.region === 'shin') return along(L, 2, Math.min(G.leg.cut, 4), 6.5);
    var p = G.leg.mid[i.region] || G.leg.mid.shin;
    return {
      c: p,
      rx: 7 * z,
      ry: 9 * z,
      rot: 0
    };
  }

  // The raw end of an amputated limb, across the limb's line.
  var Stump = function Stump(_ref6) {
    var p = _ref6.p,
      from = _ref6.from,
      w = _ref6.w;
    return /*#__PURE__*/React.createElement("g", {
      transform: "rotate(".concat(angle(from, p) - 90, " ").concat(p[0], " ").concat(p[1], ")")
    }, /*#__PURE__*/React.createElement("ellipse", {
      cx: p[0],
      cy: p[1],
      rx: w / 2,
      ry: w / 4,
      fill: "#991b1b",
      stroke: "#ef4444",
      strokeWidth: "0.6"
    }), /*#__PURE__*/React.createElement("ellipse", {
      cx: p[0],
      cy: p[1],
      rx: w / 7,
      ry: w / 9,
      fill: "#fef3c7"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M".concat(p[0] - w / 5, " ").concat(p[1] + w / 5, " q-0.6 ").concat(w / 3, " 0 ").concat(w / 1.8, " M").concat(p[0] + w / 6, " ").concat(p[1] + w / 5, " q0.6 ").concat(w / 4, " 0 ").concat(w / 2.4),
      stroke: "#b91c1c",
      strokeWidth: "1.1",
      fill: "none",
      strokeLinecap: "round"
    }));
  };
  var InjuryLayer = function InjuryLayer(_ref7) {
    var list = _ref7.list,
      g = _ref7.g;
    var z = g.z;
    return /*#__PURE__*/React.createElement("g", {
      "data-part": "injuries"
    }, list.map(function (i, k) {
      var p = pointFor(i, g);
      var id = "injury-".concat(i.region, "-").concat(i.kind);
      if (i.kind === 'pregnant') return null; // the pregnant body is drawn instead
      if (i.kind === 'burn') {
        var b = burnShape(i, g);
        return /*#__PURE__*/React.createElement("g", {
          key: k,
          "data-part": id
        }, /*#__PURE__*/React.createElement(Sprite, {
          name: "burn",
          c: b.c,
          w: b.rx * 2,
          h: b.ry * 2,
          rot: b.rot,
          opacity: 0.92
        }));
      }
      if (i.kind === 'amputation') {
        var side = i.side === 'L' ? 'L' : 'R';
        var isLeg = LEG_REGIONS.has(i.region) || i.region === 'leg';
        var limb = isLeg ? g[side].leg : g[side].arm;
        if (!limb.stump) return null;
        return /*#__PURE__*/React.createElement("g", {
          key: k,
          "data-part": id
        }, /*#__PURE__*/React.createElement(Stump, {
          p: limb.stump,
          from: limb.pts[limb.cut - 1],
          w: (isLeg ? limb.cut === 1 ? 15 : 10 : 7) * z
        }));
      }
      if (i.kind === 'evisceration') return /*#__PURE__*/React.createElement("g", {
        key: k,
        "data-part": id
      }, /*#__PURE__*/React.createElement(Sprite, {
        name: "evisceration",
        c: p,
        w: 22 * z
      }));
      if (i.kind === 'impaled') return /*#__PURE__*/React.createElement("g", {
        key: k,
        "data-part": id
      }, /*#__PURE__*/React.createElement(Sprite, {
        name: "knife",
        c: [p[0] + 4 * z, p[1] - 7 * z],
        w: 15 * z
      }));
      if (i.kind === 'wound') return /*#__PURE__*/React.createElement("g", {
        key: k,
        "data-part": id
      }, /*#__PURE__*/React.createElement(Sprite, {
        name: "laceration",
        c: p,
        w: 9 * z,
        rot: -15
      }));
      if (i.kind === 'crush') {
        if (i.region === 'leg') {
          var G = g[i.side === 'L' ? 'L' : 'R'].leg.mid;
          return /*#__PURE__*/React.createElement("g", {
            key: k,
            "data-part": id
          }, /*#__PURE__*/React.createElement(Sprite, {
            name: "bruise",
            c: G.thigh,
            w: 14 * z,
            h: 26 * z
          }), /*#__PURE__*/React.createElement(Sprite, {
            name: "abrasion",
            c: G.shin,
            w: 12 * z,
            h: 22 * z
          }));
        }
        return /*#__PURE__*/React.createElement("g", {
          key: k,
          "data-part": id
        }, /*#__PURE__*/React.createElement(Sprite, {
          name: "bruise",
          c: p,
          w: 18 * z
        }), /*#__PURE__*/React.createElement(Sprite, {
          name: "abrasion",
          c: p,
          w: 12 * z
        }));
      }
      if (i.kind === 'fracture') {
        var _limb = LEG_REGIONS.has(i.region) || ARM_REGIONS.has(i.region) || i.region === 'leg' || i.region === 'arm';
        if (i.region === 'chest') {
          var q = g.T([mx(i.side === 'L' ? 'L' : 'R', 73), 90]);
          return /*#__PURE__*/React.createElement("g", {
            key: k,
            "data-part": id
          }, /*#__PURE__*/React.createElement(Sprite, {
            name: "bruise",
            c: q,
            w: 15 * z,
            h: 19 * z
          }), /*#__PURE__*/React.createElement("path", {
            d: "M".concat(q[0] - 5, " ").concat(q[1] - 6, " l9 2 M").concat(q[0] - 5, " ").concat(q[1], " l9 2 M").concat(q[0] - 5, " ").concat(q[1] + 6, " l9 2"),
            stroke: "#fca5a5",
            strokeWidth: "0.8",
            strokeDasharray: "2 1.2"
          }));
        }
        if (i.region === 'pelvis') return /*#__PURE__*/React.createElement("g", {
          key: k,
          "data-part": id
        }, /*#__PURE__*/React.createElement(Sprite, {
          name: "bruise",
          c: g.T([95, 132]),
          w: 34 * z,
          h: 12 * z
        }));
        return /*#__PURE__*/React.createElement("g", {
          key: k,
          "data-part": id
        }, /*#__PURE__*/React.createElement(Sprite, {
          name: "swelling",
          c: p,
          w: (_limb ? 13 : 15) * z
        }), /*#__PURE__*/React.createElement(Sprite, {
          name: "bruise",
          c: p,
          w: (_limb ? 9 : 12) * z,
          opacity: 0.8
        }), i.open && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Sprite, {
          name: "laceration",
          c: [p[0] + 1, p[1] + 1],
          w: 8 * z,
          rot: 60
        }), /*#__PURE__*/React.createElement("path", {
          d: "M".concat(p[0] - 1, " ").concat(p[1] - 1, " l").concat(3 * z, " ").concat(-3 * z),
          stroke: "#fefce8",
          strokeWidth: 1.6 * z,
          strokeLinecap: "round"
        })));
      }
      // bruising, or an injury the text does not describe further
      if (i.region === 'head') return /*#__PURE__*/React.createElement("g", {
        key: k,
        "data-part": id
      }, /*#__PURE__*/React.createElement(Sprite, {
        name: "bruise",
        c: [p[0] - 6, p[1] + 2],
        w: 11 * z
      }), /*#__PURE__*/React.createElement(Sprite, {
        name: "laceration",
        c: [p[0] - 5, p[1] + 1],
        w: 7 * z,
        rot: 15
      }));
      if (i.region === 'eye') return /*#__PURE__*/React.createElement("g", {
        key: k,
        "data-part": id
      }, /*#__PURE__*/React.createElement(Sprite, {
        name: "bruise",
        c: p,
        w: 10 * z,
        h: 8 * z
      }));
      if (i.region === 'abdomen' && i.kind === 'bruise') return /*#__PURE__*/React.createElement("g", {
        key: k,
        "data-part": id
      }, /*#__PURE__*/React.createElement(Sprite, {
        name: "bruise",
        c: p,
        w: 32 * z,
        h: 9 * z,
        rot: -25
      }));
      if (i.kind === 'bruise') return /*#__PURE__*/React.createElement("g", {
        key: k,
        "data-part": id
      }, /*#__PURE__*/React.createElement(Sprite, {
        name: "bruise",
        c: p,
        w: 13 * z
      }));
      return /*#__PURE__*/React.createElement("g", {
        key: k,
        "data-part": id
      }, /*#__PURE__*/React.createElement(Sprite, {
        name: "abrasion",
        c: p,
        w: 12 * z
      }));
    }));
  };

  // The kit on the patient. `has(key)` is whether that intervention is on.
  var LIMB_TARGETS = ['thigh', 'shin', 'leg', 'knee', 'ankle', 'foot', 'hip', 'forearm', 'arm', 'upperArm', 'hand'];
  function kitPlan(list, has) {
    var kit = [];
    var fx = list.filter(function (i) {
      return i.kind === 'fracture' && LIMB_TARGETS.indexOf(i.region) !== -1;
    });
    var sideOf = function sideOf(i) {
      return i && i.side === 'L' ? 'L' : 'R';
    };
    if (has('Scoop')) kit.push({
      type: 'scoop',
      name: 'Scoop stretcher'
    });
    if (has('Collar')) kit.push({
      type: 'collar',
      name: 'Collar'
    });
    if (has('HeadBlocks')) kit.push({
      type: 'blocks',
      name: 'Head blocks'
    });
    if (has('PelvicBinder')) kit.push({
      type: 'binder',
      name: 'Pelvic binder'
    });
    if (has('TractionSplint')) {
      var t = fx.find(function (i) {
        return i.region === 'thigh' || i.region === 'hip';
      }) || fx.find(function (i) {
        return LEG_REGIONS.has(i.region) || i.region === 'leg';
      });
      kit.push({
        type: 'traction',
        side: sideOf(t),
        name: 'Traction splint'
      });
    }
    if (has('Splinting')) {
      var _t = fx.find(function (i) {
        return i.region !== 'thigh' && i.region !== 'hip';
      }) || fx[0];
      kit.push({
        type: 'splint',
        side: sideOf(_t),
        region: _t ? _t.region : 'shin',
        name: 'Splint'
      });
    }
    if (has('Plaster')) {
      var _t2 = fx.find(function (i) {
        return ['ankle', 'shin', 'leg', 'forearm', 'arm', 'hand'].indexOf(i.region) !== -1;
      });
      kit.push({
        type: 'plaster',
        side: sideOf(_t2),
        region: _t2 ? _t2.region : 'ankle',
        name: 'Backslab'
      });
    }
    if (has('Tourniquet')) {
      var bleeding = list.filter(function (i) {
        return (i.kind === 'amputation' || i.kind === 'wound' || i.kind === 'fracture' && i.open || i.kind === 'crush') && LIMB_TARGETS.indexOf(i.region) !== -1;
      });
      var limbs = {};
      bleeding.forEach(function (i) {
        limbs["".concat(sideOf(i), "|").concat(LEG_REGIONS.has(i.region) || i.region === 'leg' ? 'leg' : 'arm')] = true;
      });
      var keys = Object.keys(limbs).length ? Object.keys(limbs) : ['R|leg'];
      keys.forEach(function (k) {
        var _k$split = k.split('|'),
          _k$split2 = _slicedToArray(_k$split, 2),
          side = _k$split2[0],
          limb = _k$split2[1];
        kit.push({
          type: 'tourniquet',
          side: side,
          limb: limb,
          name: 'Tourniquet'
        });
      });
    }
    if (has('ChestSeal')) {
      var w = list.find(function (i) {
        return i.region === 'chest' && i.kind === 'wound';
      });
      kit.push({
        type: 'chestseal',
        side: w ? w.side || 'R' : 'R',
        name: 'Chest seal'
      });
    }
    if (has('WoundDressing')) kit.push({
      type: 'dressing',
      name: 'Dressing'
    });
    if (has('ClingFilm')) kit.push({
      type: 'clingfilm',
      name: 'Cling film'
    });
    return kit;
  }

  // The two ends of the part of a limb a splint or backslab covers.
  function segFor(region, side, g) {
    var G = g[side];
    var arm = G.arm.segs,
      leg = G.leg.segs,
      L = G.leg.pts;
    var first = function first(s) {
        return s.pts[0];
      },
      last = function last(s) {
        return s.pts[s.pts.length - 1];
      };
    if (region === 'upperArm') return [first(arm[0]), last(arm[0])];
    if (ARM_REGIONS.has(region) || region === 'arm') return [first(arm[1]), region === 'hand' && G.arm.hand ? G.arm.pts[5] : last(arm[1])];
    if (region === 'thigh' || region === 'hip') return [first(leg[0]), last(leg[0])];
    if (region === 'knee') return [L[1], leg[1] ? L[3] : last(leg[0])];
    if (leg[1]) {
      if (region === 'ankle' || region === 'foot') return G.leg.foot ? [L[3], L[5]] : [L[3], last(leg[1])];
      return [first(leg[1]), last(leg[1])];
    }
    return [first(leg[0]), last(leg[0])];
  }
  // A kit picture laid along a limb from a to b
  var Along = function Along(_ref8) {
    var name = _ref8.name,
      a = _ref8.a,
      b = _ref8.b,
      w = _ref8.w,
      _ref8$extra = _ref8.extra,
      extra = _ref8$extra === void 0 ? 4 : _ref8$extra;
    var len = Math.hypot(b[0] - a[0], b[1] - a[1]) + extra;
    return /*#__PURE__*/React.createElement(Sprite, {
      name: name,
      c: lerp(a, b, 0.5),
      w: len,
      h: w,
      rot: angle(a, b)
    });
  };
  var KitLayer = function KitLayer(_ref9) {
    var kit = _ref9.kit,
      list = _ref9.list,
      g = _ref9.g;
    var z = g.z,
      T = g.T;
    return /*#__PURE__*/React.createElement("g", {
      "data-part": "kit"
    }, kit.map(function (k, n) {
      // the scoop stretcher's two orange halves either side of the patient, joined at the head and feet
      if (k.type === 'scoop') {
        var _T = T([46, 0]),
          _T2 = _slicedToArray(_T, 2),
          x0 = _T2[0],
          y0 = _T2[1],
          _T3 = T([144, 246]),
          _T4 = _slicedToArray(_T3, 2),
          x1 = _T4[0],
          y1 = _T4[1];
        return /*#__PURE__*/React.createElement("g", {
          key: n,
          "data-part": "scoop",
          fill: "none",
          stroke: "#f97316",
          strokeOpacity: "0.9",
          strokeLinejoin: "round"
        }, /*#__PURE__*/React.createElement("rect", {
          x: x0,
          y: y0,
          width: x1 - x0,
          height: y1 - y0,
          rx: 10 * z,
          strokeWidth: 3.2 * z
        }), /*#__PURE__*/React.createElement("path", {
          d: "M".concat(x0 + 4 * z, " ").concat(y0 + 4 * z, " V").concat(y1 - 4 * z, " M").concat(x1 - 4 * z, " ").concat(y0 + 4 * z, " V").concat(y1 - 4 * z),
          strokeWidth: 0.8 * z,
          strokeDasharray: "".concat(4 * z, " ").concat(3 * z)
        }));
      }
      // head blocks either side of the head, and the tape across the forehead and chin
      if (k.type === 'blocks') {
        var w = 9 * g.F.kx,
          h = 26 * g.F.ky;
        var _T5 = T([75.5, 25]),
          _T6 = _slicedToArray(_T5, 2),
          lx = _T6[0],
          ly = _T6[1],
          _T7 = T([114.5, 25]),
          _T8 = _slicedToArray(_T7, 1),
          rx = _T8[0];
        var _T9 = T([77, 18]),
          _T0 = _slicedToArray(_T9, 2),
          tx0 = _T0[0],
          ty = _T0[1],
          _T1 = T([113, 43]),
          _T10 = _slicedToArray(_T1, 2),
          tx1 = _T10[0],
          cy = _T10[1];
        return /*#__PURE__*/React.createElement("g", {
          key: n,
          "data-part": "blocks"
        }, /*#__PURE__*/React.createElement("rect", {
          x: lx - w / 2,
          y: ly - h / 2,
          width: w,
          height: h,
          rx: 2.5 * z,
          fill: "#f97316",
          stroke: "#7c2d12",
          strokeWidth: 0.6 * z
        }), /*#__PURE__*/React.createElement("rect", {
          x: rx - w / 2,
          y: ly - h / 2,
          width: w,
          height: h,
          rx: 2.5 * z,
          fill: "#f97316",
          stroke: "#7c2d12",
          strokeWidth: 0.6 * z
        }), /*#__PURE__*/React.createElement("rect", {
          x: tx0,
          y: ty - 1.6 * z,
          width: tx1 - tx0,
          height: 3.2 * z,
          fill: "#fde68a",
          fillOpacity: "0.9",
          stroke: "#92400e",
          strokeWidth: 0.4 * z
        }), /*#__PURE__*/React.createElement("rect", {
          x: tx0,
          y: cy - 1.6 * z,
          width: tx1 - tx0,
          height: 3.2 * z,
          fill: "#fde68a",
          fillOpacity: "0.9",
          stroke: "#92400e",
          strokeWidth: 0.4 * z
        }));
      }
      if (k.type === 'collar') return /*#__PURE__*/React.createElement("g", {
        key: n,
        "data-part": "collar"
      }, /*#__PURE__*/React.createElement(Sprite, {
        name: "collar",
        c: T([95, 53]),
        w: 25 * g.F.kx,
        h: 26 * g.F.ky
      }));
      if (k.type === 'binder') return /*#__PURE__*/React.createElement("g", {
        key: n,
        "data-part": "binder"
      }, /*#__PURE__*/React.createElement(Sprite, {
        name: "binder",
        c: T([95, 131]),
        w: 72 * g.F.kx,
        h: 17 * g.F.ky
      }));
      if (k.type === 'traction') {
        var L = g[k.side].leg;
        var end = L.ankle || L.stump;
        var top = lerp(L.pts[0], L.pts[1], -0.2);
        var tip = lerp(L.pts[2], end, 1.45);
        // the picture runs from the pole's end (left) to the ischial pad (right)
        return /*#__PURE__*/React.createElement("g", {
          key: n,
          "data-part": "traction"
        }, /*#__PURE__*/React.createElement(Along, {
          name: "traction",
          a: tip,
          b: top,
          w: 13 * z,
          extra: 0
        }));
      }
      if (k.type === 'splint' || k.type === 'plaster') {
        var _segFor = segFor(k.region, k.side, g),
          _segFor2 = _slicedToArray(_segFor, 2),
          a = _segFor2[0],
          b = _segFor2[1];
        var leg = !(ARM_REGIONS.has(k.region) || k.region === 'arm');
        return /*#__PURE__*/React.createElement("g", {
          key: n,
          "data-part": k.type
        }, /*#__PURE__*/React.createElement(Along, {
          name: k.type === 'splint' ? 'vacsplint' : 'plaster',
          a: a,
          b: b,
          w: (leg ? 16 : 12) * z,
          extra: 6 * z
        }));
      }
      if (k.type === 'tourniquet') {
        var P = k.limb === 'leg' ? g[k.side].leg.pts : g[k.side].arm.pts;
        var cut = (k.limb === 'leg' ? g[k.side].leg : g[k.side].arm).cut;
        // above the wound: high on the thigh or upper arm, higher still above a stump there
        var p = lerp(P[0], P[1], k.limb === 'leg' ? cut === 1 ? 0.3 : 0.62 : 0.5);
        var _w = (k.limb === 'leg' ? 24 : 17) * z;
        return /*#__PURE__*/React.createElement("g", {
          key: n,
          "data-part": "tourniquet"
        }, /*#__PURE__*/React.createElement(Sprite, {
          name: "tourniquet",
          c: p,
          w: _w,
          h: _w * 0.32,
          rot: angle(P[0], P[1]) - 90
        }));
      }
      if (k.type === 'chestseal') return /*#__PURE__*/React.createElement("g", {
        key: n,
        "data-part": "chestseal"
      }, /*#__PURE__*/React.createElement(Sprite, {
        name: "chestseal",
        c: T(POINT.chest(k.side)),
        w: 15 * z
      }));
      if (k.type === 'dressing') {
        var spots = list.filter(function (i) {
          return ['wound', 'amputation', 'evisceration', 'impaled'].indexOf(i.kind) !== -1 || i.kind === 'fracture' && i.open;
        });
        return /*#__PURE__*/React.createElement("g", {
          key: n,
          "data-part": "dressing"
        }, spots.map(function (i, m) {
          var p = pointFor(i, g);
          if (i.kind === 'amputation') {
            var s = i.side === 'L' ? 'L' : 'R';
            p = (LEG_REGIONS.has(i.region) || i.region === 'leg' ? g[s].leg.stump : g[s].arm.stump) || p;
          }
          return /*#__PURE__*/React.createElement(Sprite, {
            key: m,
            name: "dressing",
            c: p,
            w: (i.kind === 'evisceration' ? 20 : 11) * z
          });
        }));
      }
      if (k.type === 'clingfilm') return /*#__PURE__*/React.createElement("g", {
        key: n,
        "data-part": "clingfilm"
      }, list.filter(function (i) {
        return i.kind === 'burn';
      }).map(function (i, m) {
        var b = burnShape(i, g);
        return /*#__PURE__*/React.createElement("g", {
          key: m,
          transform: b.rot ? "rotate(".concat(b.rot, " ").concat(b.c[0], " ").concat(b.c[1], ")") : undefined
        }, /*#__PURE__*/React.createElement("ellipse", {
          cx: b.c[0],
          cy: b.c[1],
          rx: b.rx + 1.5,
          ry: b.ry + 1.5,
          fill: "#e0f2fe",
          fillOpacity: "0.28",
          stroke: "#f8fafc",
          strokeOpacity: "0.7",
          strokeWidth: "0.6"
        }), /*#__PURE__*/React.createElement("path", {
          d: "M".concat(b.c[0] - b.rx * 0.6, " ").concat(b.c[1] - b.ry * 0.2, " l").concat(b.rx * 0.5, " ").concat(-b.ry * 0.4),
          stroke: "#ffffff",
          strokeOpacity: "0.7",
          strokeWidth: "0.8"
        }));
      }));
      return null;
    }));
  };

  // ---- the editor ---------------------------------------------------------------------------
  // The list with Remove buttons and the "Add" row: inside the Injuries window below, and in the
  // controller's "Set up the patient" window (data/screens/patientstatus.js).
  function InjuryPicker(_ref0) {
    var scenario = _ref0.scenario,
      onChange = _ref0.onChange;
    var _window = window,
      Button = _window.Button;
    var list = forScenario(scenario);
    var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      pick = _useState2[0],
      setPick = _useState2[1];
    var _useState3 = useState('R'),
      _useState4 = _slicedToArray(_useState3, 2),
      side = _useState4[0],
      setSide = _useState4[1];
    var preset = PRESETS[pick];
    var add = function add() {
      var sides = preset.sided ? side === 'both' ? ['R', 'L'] : [side] : [preset.region === 'chest' && preset.kind === 'burn' ? 'C' : null];
      var next = list.concat(sides.map(function (s) {
        return {
          region: preset.region,
          kind: preset.kind,
          side: s,
          open: false,
          guessed: false
        };
      }));
      onChange(tidy(next.map(function (i) {
        return Object.assign({}, i);
      })));
    };
    var remove = function remove(n) {
      return onChange(list.filter(function (_, m) {
        return m !== n;
      }));
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "space-y-1.5 overflow-y-auto flex-grow pr-1 mb-3",
      "data-testid": "injury-list"
    }, list.length === 0 && /*#__PURE__*/React.createElement("p", {
      className: "text-sm text-slate-400 italic"
    }, "No injuries."), list.map(function (i, n) {
      return /*#__PURE__*/React.createElement("div", {
        key: n,
        className: "flex items-center justify-between gap-2 bg-slate-900 border border-slate-700 rounded px-2 py-1.5"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-sm text-slate-100"
      }, label(i)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: function onClick() {
          return remove(n);
        },
        "aria-label": "Remove ".concat(label(i)),
        className: "text-[10px] uppercase font-bold px-2 py-1 rounded border border-slate-600 text-slate-300 hover:bg-slate-700"
      }, "Remove"));
    })), /*#__PURE__*/React.createElement("div", {
      className: "border-t border-slate-700 pt-3 flex flex-wrap gap-2 items-end"
    }, /*#__PURE__*/React.createElement("label", {
      className: "flex flex-col gap-1 text-[11px] text-slate-400 font-bold uppercase flex-1 min-w-[12rem]"
    }, "Add", /*#__PURE__*/React.createElement("select", {
      value: pick,
      onChange: function onChange(e) {
        return setPick(Number(e.target.value));
      },
      "aria-label": "Injury to add",
      className: "bg-slate-900 border border-slate-600 rounded px-2 h-9 text-sm text-white normal-case font-normal"
    }, PRESETS.map(function (p, n) {
      return /*#__PURE__*/React.createElement("option", {
        key: n,
        value: n
      }, p.name);
    }))), preset.sided && /*#__PURE__*/React.createElement("label", {
      className: "flex flex-col gap-1 text-[11px] text-slate-400 font-bold uppercase"
    }, "Side", /*#__PURE__*/React.createElement("select", {
      value: side,
      onChange: function onChange(e) {
        return setSide(e.target.value);
      },
      "aria-label": "Side",
      className: "bg-slate-900 border border-slate-600 rounded px-2 h-9 text-sm text-white normal-case font-normal"
    }, /*#__PURE__*/React.createElement("option", {
      value: "R"
    }, "Right"), /*#__PURE__*/React.createElement("option", {
      value: "L"
    }, "Left"), /*#__PURE__*/React.createElement("option", {
      value: "both"
    }, "Both"))), /*#__PURE__*/React.createElement(Button, {
      onClick: add,
      variant: "primary",
      className: "h-9 px-4"
    }, "Add")));
  }
  function InjuryEditor(_ref1) {
    var scenario = _ref1.scenario,
      onChange = _ref1.onChange,
      onClose = _ref1.onClose;
    var _window2 = window,
      Modal = _window2.Modal,
      Button = _window2.Button,
      Lucide = _window2.Lucide;
    var own = Array.isArray(scenario.injuries);
    return /*#__PURE__*/React.createElement(Modal, {
      fixed: true,
      label: "Injuries on the patient picture",
      onClose: onClose
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-5 rounded-lg border border-slate-600 w-full max-w-lg shadow-2xl max-h-[90vh] flex flex-col",
      "data-testid": "injury-editor"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-start mb-3 gap-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "min-w-0"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white uppercase tracking-wider"
    }, "Injuries"), /*#__PURE__*/React.createElement("p", {
      className: "text-[11px] text-slate-400"
    }, "What the patient picture shows. ", own ? 'You have changed the list.' : 'Read from the scenario’s own words.', " The team sees the picture only when you show it on the monitor.")), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Close",
      onClick: onClose,
      className: "text-slate-400 hover:text-white flex-none"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "x",
      className: "w-5 h-5"
    }))), /*#__PURE__*/React.createElement(InjuryPicker, {
      scenario: scenario,
      onChange: onChange
    }), /*#__PURE__*/React.createElement("div", {
      className: "border-t border-slate-700 pt-3 mt-3 grid grid-cols-2 gap-2"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return onChange(null);
      },
      variant: "secondary",
      className: "w-full",
      disabled: !own
    }, "Scenario's own"), /*#__PURE__*/React.createElement(Button, {
      onClick: onClose,
      variant: "outline",
      className: "w-full"
    }, "Done"))));
  }
  window.Injuries = {
    detect: detect,
    forScenario: forScenario,
    label: label,
    PRESETS: PRESETS,
    geometry: geometry,
    pointFor: pointFor,
    kitPlan: kitPlan,
    Sprite: Sprite,
    Body: Body,
    InjuryLayer: InjuryLayer,
    KitLayer: KitLayer,
    InjuryPicker: InjuryPicker,
    InjuryEditor: InjuryEditor
  };
})();